import server from './server'
import { isEqual } from './utils'
import store from '../store/vuex'

/* eslint-disable */
// https://docs.google.com/spreadsheets/d/1xHvGvshOPPZawstl8fDj4_ul5JFs4C0sbgZ7yWACQlA/edit#gid=435244376
const gaEvents = {
  hasInit: false,
  hasInsertGaScript: false,
  gaSets: {
    'dimension1': '',
    // 'dimension2': '',
    'dimension3': '',
    // 'dimension4': '',
    'dimension5': '',
    'dimension7': '',
    'dimension8': ''
  },
  init (url = location.pathname) {
    if (!this.hasInsertGaScript) {
      const gaUrl = `https://www.googletagmanager.com/gtag/js?id=${server.gaId}`
      ;(function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date()
        a = s.createElement(o),
          m = s.getElementsByTagName(o)[0]
        a.async = 1
        a.src = g
        m.parentNode.insertBefore(a, m)
      })(window, document, 'script', gaUrl, 'ga')
      // disable auto pageview
      gtag('config', server.gaId, {
        send_page_view: false,
        cookie_flags: 'max-age=7200;secure;samesite=none'
      })
      gtag('config', server.ga4Id, {
        send_page_view: false,
        cookie_flags: 'max-age=7200;secure;samesite=none'
      })
      this.hasInsertGaScript = true
    }

    const username = store.state.user.user.username
    const headquarterId = store.state.user.headquarter.objectId
    const userHeadquarterId = store.state.user.user.headquarter.objectId
    const buildingId = store.state.route.params.buildingId || store.state.buildings.currentBuilding.objectId || ''
    const propertyId = store.state.route.query.group || store.state.property.property.objectId || ''
    const shouldCheckProperty = store.state.route.query.group
    const shouldCheckHeadquarter = store.state.route.name !== 'default'
    const planTitle = store.state.user.user.planTitle
    // dimension1: username
    // dimension2: headquarterIdUrlHasTitle, had been deprecated
    // dimension3: headquarterId
    // dimension4: deviceType, had been deprecated
    // dimension5: buildingId
    // dimension6: sharecode, had been deprecated
    // dimension7: propertyId
    // dimension8: planTitle
    // dimension9: panoramaId <'buildingViews','__realPanoramaId__'>
    // dimension10: visitor username

    // user will have customSetting, headquarter default value
    // if (!Object.keys(user).length || !buildingId || (shouldCheckProperty && !propertyId)) {
    if (!username || !buildingId ||
      (shouldCheckProperty && !propertyId) ||
      (shouldCheckHeadquarter && (!headquarterId || !userHeadquarterId))) {
      return
    }
    const gaSets = {
      dimension1: store.state.user.user.username || '',
      // dimension2: store.state.user.headquarter.objectId || '',
      dimension3: store.state.user.user.headquarter.objectId || '',
      // dimension4: 'Web',
      dimension5: buildingId,
      dimension7: propertyId,
      dimension8: planTitle,
      dimension10: '',
      send_page_view: false,
      cookie_flags: 'max-age=7200;secure;samesite=none'
    }
    if (!isEqual(this.gaSets, gaSets)) {
      this.gaSets = gaSets
      gtag('config', server.gaId, gaSets)
      gtag('config', server.ga4Id, gaSets)
      gtag('event', 'page_view', {
        page_path: url,
        dimension9: 'buildingViews'
      })
      const panoramas = store.state.panoramas.panoramas
      if (panoramas.length > 0) {
        this.sendSceneView()
      }
    }
    this.hasInit = true
  },
  sendSceneView () {
    const url = location.pathname
    const panoramas = store.state.panoramas.panoramas
    const pageIndex = Number(store.state.route.query.index) || 1 // default from 1
    const dataIndex = pageIndex - 1
    const targetPanoramaId = panoramas[dataIndex].objectId

    // the setting (disable auto pageview) must be repeated on every page
    // https://developers.google.com/analytics/devguides/collection/gtagjs/pages#manual_pageviews
    gtag('config', server.gaId, this.gaSets)
    gtag('config', server.ga4Id, this.gaSets)
    gtag('event', 'page_view', {
      page_path: url,
      dimension9: targetPanoramaId
    })
  },
  queuedEvents: [],
  sendEvent (category = '', action = '', label = '') {
    if (!this.hasInit) {
      // This is for handling the messy race conditions
      this.queuedEvents.push([
        category,
        action,
        label
      ])
      this.init()
    }
    if (this.hasInit) {
      const visitorUsername = store.state.auth.username
      gtag('event', action, {
        event_category: category,
        event_label: label,
        dimension10: visitorUsername || ''
      })
      if (this.queuedEvents.length) {
        const event = this.queuedEvents.splice(0, 1)
        const [ec, ea, el] = event[0]
        this.sendEvent(ec, ea, el)
      }
      const shouldShowGaConsole = false
      if (shouldShowGaConsole) {
        console.log(`GA: ${category}, ${action}, ${label}`)
      }
    }
  }
}
/* eslint-enable */

export default gaEvents
